import { render } from "./uni_pieChart.vue?vue&type=template&id=77d5cd58"
import script from "./uni_pieChart.vue?vue&type=script&lang=js"
export * from "./uni_pieChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__